// Чанки и ассеты загружаются из той же директории, что и сам бандл
__webpack_public_path__ = document.currentScript.src.replace(/[^/]*$/, '');



//////////////////
// WEBPACK FOOTER
// ./src/public_path.js
// module id = 963
// module chunks = 0